/* eslint-disable no-console */
import { ApiClient } from "zoox-infra";

export default class FNRHService {
  constructor() {
    this.apiClient = new ApiClient();
  }

  /**
   * Updates a fnrh
   * @param  {String} id          fnrh Id
   * @param  {Object} fnrh fnrh Data
   * @return {[type]}             [description]
   */
  update(id, fnrhData) {
    return this.apiClient.put(`open/fnrh/${id}/documents`, fnrhData);
  }

  /**
   * Obtains a fnrh by Id
   * @param  {String} id fnrh Id
   * @return {[type]}    [description]
   */
  getOne(id) {
    return this.apiClient.get(`open/fnrh/${id}/documents`);
  }
}
